/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listConvos.defs'
export { main as default } from './listConvos.defs'
